import React, {Component} from 'react';
import EpicMenu from '../componentes/Menus/EpicMenu';
import '../componentes/styles.css'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import Trabajo from '../componentes/CompletarTrabajo/Trabajo';

class PaginaTrabajoHecho extends Component{
	constructor(props){
		super(props);
		this.app= firebase;
		this.database = this.app.firestore().collection('TareasAsignadas').where('estado', '==', 'pendiente');
		this.state = {
			trabajos: [],
		}
		const today = new Date();
	}

	terminarPendiente=(trabajo)=>{
		const batch=firebase.firestore().batch()
		const pagos=firebase.firestore().collection('Pagos')
		batch.update(firebase.firestore().collection('TareasAsignadas').doc(trabajo.trabajoID), {
			estado:"completado", 
			fechaCompletado:this.today,
		})
		if(!trabajo.nomina || trabajo.nomina==='tarea'){
			for(let i=0; i<trabajo.empleados.length; i++){
				batch.set(pagos.doc(), {
					trabajoId:trabajo.trabajoID,
					descripcion:trabajo.descripcion,
					empleado:trabajo.empleados[i],
					nombreActividad:trabajo.nombreActividad,
					trabajoHecho:trabajo.trabajoHecho,
					precio:trabajo.precio,
					unidades:trabajo.unidad,
					dificultad:trabajo.dificultad,
					areaHecha:trabajo.area,
					numInvolucrados:trabajo.empleados.length,
					estado:'pendiente',
					fecha:this.today				
				})
			}
		}
		else{
			for(let i=0; i<trabajo.empleados.length; i++){
				batch.set(pagos.doc(), {
					trabajoId:trabajo.trabajoID,
					descripcion:trabajo.descripcion,
					empleado:trabajo.empleados[i],
					nombreActividad:trabajo.nombreActividad,
					trabajoHecho:trabajo.trabajoHecho,
					precio:0,
					unidades:trabajo.unidad,
					dificultad:trabajo.dificultad,
					areaHecha:trabajo.area,
					numInvolucrados:trabajo.empleados.length,
					estado:'completado',
					fecha:this.today				
				})
			}
		}
		batch.commit().then(()=>{}).catch(e=>{alert(e)})
	}
	componentDidMount(){
		this.database.onSnapshot(querySnapshot =>{
			const trabajos=[]
			for(let i=0; i<querySnapshot.docs.length; i++){
				const doc=querySnapshot.docs[i]
				if(!doc.exists) break
				let trabajo={
					trabajoID: doc.id,
					trabajoHecho:doc.data().longitudTrabajo,
					nombreActividad: doc.data().nombreActividad,
					descripcion: doc.data().descripcion,
					area: doc.data().areaAsignada,
					unidad:doc.data().unidad,
					dificultad:doc.data().dificultad,
					precioUnitario:doc.data().precioUnitario,
					precio: doc.data().precioTotal,
					empleados: doc.data().empleados,
					estado: doc.data().estado,
					fechaEntrega: doc.data().fechaEntrega,
					nomina:doc.data().nomina,
				}
				if(trabajo.unidad==='cajas'){
					trabajo={
						...trabajo,
						cajas6:0,
						cajas12:doc.data().cajas6,
						cajas18:doc.data().cajas12,
						cajas6Precio:doc.data().cajas6Precio,
						cajas12Precio:doc.data().cajas12Precio,
						cajas18Precio:doc.data().cajas18Precio,
						nomina:doc.data().nomina,
					}
				}
				trabajos.push(trabajo)
			}
			this.setState({
				trabajos: trabajos
			})
		})
	}

	render(){
		return (
		<div>
			<div className='header'>
				<EpicMenu />
				<div className='inline'>Tareas Asignadas</div>
			</div>
			<div className="body tabla">
				<table><tbody>
					<tr>
						<th>Empleado</th>
						<th>Actividad</th>
						<th>Días Faltantes</th>
						<th>Descripcion</th>
						<th>Area Asignada</th>
						<th>Trabajo Hecho</th>
						<th>Sueldo</th>
						<th>Finalizar</th>
					</tr>
					{
						this.state.trabajos.map((trabajo) => {
							return (
								<tr key={trabajo.trabajoID}><Trabajo    
									{...trabajo}
									key={trabajo.trabajoID}
									removeAct ={this.removeAct}
									terminarPendiente ={this.terminarPendiente}
								/></tr>
							)
						})
					} 
				</tbody></table>
			</div>
			<div className="footer" >
				<div className="footer1" >
				</div>
				<div className="footer2" ></div>
			</div>
		</div>
		);
	}
}

export default PaginaTrabajoHecho;




